// removed by extract-text-webpack-plugin
module.exports = {"NavItem":"NavItem__NavItem__r-b9L","active":"NavItem__active__2ZZNc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavItems/NavItem/NavItem.css
// module id = 84
// module chunks = 3